import { render, staticRenderFns } from "./QuickSearchCollection.vue?vue&type=template&id=40638e56"
import script from "./QuickSearchCollection.vue?vue&type=script&lang=js"
export * from "./QuickSearchCollection.vue?vue&type=script&lang=js"
import style0 from "./QuickSearchCollection.vue?vue&type=style&index=0&id=40638e56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports